import axios from 'axios';
import { API_URL } from '@/store';

// TODO: настроить хэшированную отправку паролей на сервер, а не в открытом виде
class AuthService {
  login(user) {
    return axios
      .post(API_URL, {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.access) {
          localStorage.setItem('user', JSON.stringify(response.data));
          localStorage.setItem('is_onetime_password', response.data.is_onetime_password);
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  // TODO: у нас нету регистрации пользователей, так что эту функцию можно удалить, если не планируется добавлять регистрацию в будущем
  // register(user) {
  //   return axios.post(API_URL + 'signup', {
  //     username: user.username,
  //     email: user.email,
  //     password: user.password
  //   });
  // }
}

export default new AuthService();
